import UrqlClient from '../client';
import { getSdk } from './sdk.account';

if (!import.meta.env.VITE_APP_ENDPOINT) new Error('Нет переменной VITE_APP_ENDPOINT');

export const accountClient = new UrqlClient(`${import.meta.env.VITE_APP_ENDPOINT}/mobile/ob-account-service/graphql`);
const sdkAccountService = getSdk(accountClient);

export * from './sdk.account';
export default sdkAccountService;
